
import gallery from '@/pages/Gallery/index.vue'
export default [
	{
		name: 'gallery',
		path: '/gallery',
		redirect: {
			name: 'zcool'
		},
		component: gallery,
		children: [
			{
				name: 'zcool',
				path: 'pic',
				component: () => import('@/pages/Gallery/Zcool')
			},
			{
				name: 'pic-record',
				path: 'pic-record',
				component: () => import('@/pages/Gallery/Zcool')
			}
		]
	}
]
